import script from "./RoutingAddressesEmptySiren.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoutingAddressesEmptySiren.vue?vue&type=script&setup=true&lang=ts"

import "./RoutingAddressesEmptySiren.vue?vue&type=style&index=0&id=14c8ca82&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14c8ca82"]])

export default __exports__